import { Component } from '@angular/core';

@Component({
  selector: 'app-msmeverify',
  templateUrl: './msmeverify.component.html',
  styleUrls: ['./msmeverify.component.css']
})
export class MsmeverifyComponent {
  ShowCard:any;
}
